
export const FILE_URL = "https://api-digital-tex.tsul.uz/";
export const QR_LOGIN_URL="http://std.tsul.uz"
